<template>
  <div class="wrap">
    <div class="banner">
      <div class="text animated fadeIn">
        <p class="icon"></p>
        <p class="h2">工程项目案例</p>
      </div>
    </div>
    <div class="content"
         id="a2">
      <div class="en t2"></div>
      <div class="inner product">
        <h2>服务案例</h2>
        <div class="step">
          <ul>
            <li v-for="(item, index) in teamList" :key="index" @click="godetails(item)">
              <img :src="item.url" />
              <div class="overlay">
                <p>{{ item.name }}</p>
                <p class="titp">{{ item.title }}</p>
                <p class="titp">{{ item.title1 }}</p>
                <p class="titp">{{ item.title2 }}</p>
                <p class="titp">{{ item.title3 }}</p>
                <p class="titp">{{ item.title4 }}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'EngineeringCases',
  data () {
    return {
      teamList: [
        {
          id: 1,
          url: require('../../assets/images/airsep/engineeringCases1.png'),
          name: '黄冈市中医院',
          title: '客户反馈：',
          title1: '1、自主研发、生产的设备在质量上是有根本保障的，具备运行维护管理系统软件，管理无需人值守，智能化管理，效率高；',
          title2: '2、独有专利组件分子筛解析器，保证分子筛使用寿命，确保氧气质量；',
          title3: '3、技术成熟，专业而敬业',
          title4: '4、是医院配置医用制氧设备的最理想厂家；'
        },
        {
          id: 2,
          url: require('../../assets/images/airsep/engineeringCases2.png'),
          name: '贵阳市公共卫生救治中心',
          title: '客户反馈：',
          title1: '1、专业的团队，成熟的技术，无后顾之忧。',
          title2: '2、服务到位，严格把关',
          title3: '3、是医院配置医用制氧设备的最理想厂家；',
          title4: ''
        },
        {
          id: 3,
          url: require('../../assets/images/airsep/engineeringCases33.jpg'),
          name: '桂林解放军181医院',
          title: '客户反馈:',
          title1: '1、有专业的团队保障，买的放心，用得安心；',
          title2: '2、设备生产在材料及工艺都很讲究，货真价实，是低噪音、低能耗、低耗材量设计系统设备，特别是独有的分子筛解析器，，使分子筛使用时间长，制氧质量安全稳定；',
          title3: '3、专业、敬业、谦虚的运营团队，让医院有安全感，无后顾之忧。',
          title4: '4、是医院购置医用制氧设备的最理想厂家；'
        },
        {
          id: 4,
          url: require('../../assets/images/airsep/engineeringCases44.jpg'),
          name: '广西中医院大学附属医院',
          title: '客户反馈：',
          title1: '1、自主研发、生产的设备在质量上是有根本保障的，具备运行维护管理系统软件，管理无需人值守，智能化管理，效率高；',
          title2: '2、独有专利组件分子筛解析器，保证分子筛使用寿命，确保氧气质量；',
          title3: '3、技术成熟，专业而敬业，设备正常运行多年，无后顾之忧。',
          title4: '4、是医院配置医用制氧设备的最理想厂家；'
        },
        {
          id: 5,
          url: require('../../assets/images/airsep/engineeringCases5.png'),
          name: '湖南中医药大学第一附属医院',
          title: '客户反馈：',
          title1: '1、正常运营多年，质量技术很有保障',
          title2: '2、技术团队认真负责，为医院打造了一支专业的运营团队，保证设备正常运行，让医院无后顾之忧。',
          title3: '',
          title4: ''
        },
        {
          id: 6,
          url: require('../../assets/images/airsep/engineeringCases6.png'),
          name: '长沙市第四医院',
          title: '客户反馈：',
          title1: '1、为医院量身定做，材料和工艺非常讲究，技术非常成熟，设备正常运行十年了，不得不赞。',
          title2: '2、独有的分子筛解析器，同时采用美国UOP最新型医用分子筛，分子筛使用时间很长，制氧质量安全稳定。',
          title3: '3、技术团队认真负责，为医院打造了一支专业的运营团队，保证设备正常运行，让医院无后顾之忧。',
          title4: ''
        }
      ]
    }
  },
  mounted () {
  },
  watch: {
  },
  methods: {
    godetails (item) {
      this.$router.push({ name: 'Detail', params: { item: item } })
      // const routeData = this.$router.push({ name: 'Detail', params: { item: item } })
      // window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.banner {
  width: 100%;
  height: 444px;
  margin-top: 76px;
  background: url('../../assets/images/banner4.png') no-repeat center;
  text-align: center;
  overflow: hidden;
  .text {
    display: inline-block;
    margin: 117px auto 0;
  }
  .icon {
    width: 105px;
    height: 105px;
    margin: 0 auto;
    background: url('../../assets/images/banner4-icon.png') no-repeat center;
    border-radius: 50%;
    background-color: #ffffff;
  }
  .h2 {
    font-size: 30px;
    color: #fff;
    margin-top: 62px;
  }
}
.content {
  position: relative;
  padding: 80px 0 55px;
  .en {
    width: 100%;
    height: 69px;
    text-align: center;
    border-bottom: 1px solid #f3f3f3;
    position: absolute;
    top: 80px;
    left: 0;
    background-position: center top;
    background-repeat: no-repeat;
    &.t1 {
      background-image: url('../../assets/images/Company-introduction.png');
    }
    &.t2 {
      background-image: url('../../assets/images/Enterprise-development.png');
    }
    &.t3 {
      background-image: url('../../assets/images/Corporate-honor.png'); // 企业荣誉
    }
    &.t4 {
      background-image: url('../../assets/images/Contact-us.png');
    }
    &.t5 {
      background-image: url('../../assets/images/Contact-zizhi.png');
    }
  }
  .product {
    position: relative;
    z-index: 1;
    h2 {
      width: 338px;
      height: 68px;
      line-height: 68px;
      color: #6a6a6a;
      font-size: 24px;
      border-bottom: 2px solid #00dcd4;
      text-align: center;
      margin: 0 auto;
      em {
        color: #00dcd4;
      }
    }
    .details {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 80px 0;
      .img {
        width: 558px;
        min-height: 314px;
        position: relative;
        .p1 {
          width: 558px;
          height: 262px;
          margin-top: 26px;
          background: #d6f8f7;
        }
        .p2 {
          width: 468px;
          height: 314px;
          margin: 0 auto;
          position: absolute;
          top: 0;
          left: 45px;
          img {
            width: 100%;
          }
        }
      }
      .text {
        width: 598px;
        margin-top: 49px;
        position: relative;
        p {
          text-indent: 2em;
          font-size: 18px;
          line-height: 36px;
          color: #6a6a6a;
        }
      }
    }
    .step {
      column-count: 3;
      column-gap: 15px;
      margin: 80px 0;
      ul{
        padding: 0;
        margin: 0;
        list-style: none;
        li{
          break-inside: avoid;
          margin-bottom: 15px;
          position: relative;
          cursor: pointer;
          img{
            width: 100%;
            display: block;
            border: 1px solid #fff;
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1);
            border-radius: 8px;
          }
          .overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: rgba(0, 0, 0, 0.5);
            color: white;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            opacity: 0;
            transition: opacity 0.3s;
            p {
              font-size: 14px;
              margin: 0;
              padding: 10px;
              line-height: 20px;
              width: 100%;
              display: flex;
              justify-content: center;
            }
            .titp{
              display: flex;
              justify-content: flex-start;
              padding-top: 0px;
            }
          }
        }
        li:hover .overlay{
          opacity: 1;
        }
      }
    }
    .map img {
      display: block;
      margin: 0 auto;
      padding: 30px;
      background: #fafafc;
      border-radius: 10px;
    }
  }
}
</style>
